import { Link, useSearchParams } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { CheckCircle, ArrowLeft } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";

export default function OrderSuccess() {
  const { t } = useLanguage();
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get("session_id");
  const booked = searchParams.get("booked");

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4">
      <div className="max-w-md w-full text-center">
        <div className="w-20 h-20 rounded-full bg-green-100 flex items-center justify-center mx-auto mb-6">
          <CheckCircle className="w-10 h-10 text-green-600" />
        </div>
        <h1 className="font-display text-3xl text-foreground mb-3">
          {t("order_success_title")}
        </h1>
        <p className="text-muted-foreground mb-2">
          {t("order_success_desc")}
        </p>
        {sessionId && (
          <p className="text-xs text-muted-foreground/60 mb-6 font-mono">
            Ref: {sessionId.slice(0, 20)}...
          </p>
        )}
        {booked && !sessionId && (
          <>
            <h1 className="font-display text-3xl text-foreground mb-3">
              {t("order_interest_success")}
            </h1>
            <p className="text-sm text-muted-foreground mb-6">
              {t("order_interest_success_desc")}
            </p>
          </>
        )}
        <Button variant="heroPrimary" size="lg" asChild>
          <Link to="/">
            <ArrowLeft className="w-5 h-5 mr-2" />
            {t("order_back")}
          </Link>
        </Button>
      </div>
    </div>
  );
}
